// NOTE: Should be the slug field of each feature in the DB
export enum AppFeatures {
  ThirdPartyIntegrations = 'third-party-integrations',
  Alerts = 'alerts',
  GoogleDrive = 'google-drive-integration',
  EmailDocumentForwarding = 'email-document-forwarding',
}
